import $http from '$http';
import {
    cloneDeep,
    util,
    lg
} from 'utils';

export default {
    methods: {
        //POST /api/UserOrder / UserOrderAdd
        getAddOrderList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;

            $http.post("api/UserOrder/UserOrderAdd", Object.assign({}, params, this.form)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    // this.$notify({
                    //     title: '成功',
                    //     message: '下单成功',
                    //     type: 'success'
                    // });
                    this.dialogVisible = true

                });
            });
        },
        // 修改POST /api/UserOrder/UserOrderModify
        UserOrderModify() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;

            $http.post("api/UserOrder/UserOrderModify", Object.assign({}, params, this.ModifyData)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功！',
                        type: 'success'
                    });
                    this.$router.push("/Family/OrderList");
                });
            });
        },
        //获取单条数据
        getById(OrderId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                OrderId: OrderId,
            };
            this.loading = true;
            // this.orderInfoData = {}; //存储下单信息
            // this.RefereeInfoData = {}; //存储转介绍人信息
            $http.get("api/UserOrder/GetOrderById", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.form.OrderSource = Data.OrderSource
                    this.form.PackageId=Data.PackageId
                    if (this.form.OrderSource == 4) {
                        // 团购数

                        this.form.GroupPeopleNum = Data.GroupList.length + 1
                    }
                    // 转介绍信息
                    this.RefereeInfoData = {
                        RefereeBabyInfoData: Data.RefereeBabyInfo,
                        RefereeParentInfoData: Data.RefereeParentInfo,
                        RefereeAgentInfoData: Data.RefereeBabyAgentInfo,
                        RefereeSchoolInfoData: Data.RefereeBabySchoolInfo,
                        RefereeClassInfoData: Data.RefereeBabyClassInfo
                    }
                    // 下单信息
                    this.orderInfoData = cloneDeep(Data)
                    // this.$nextTick(() => {
                    //     console.log(this.orderNum)
                    // })




                });
            });
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/LBHomeOrder/services.js